import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=4dcfb7b8&scoped=true&lang=pug"
import script from "./add-or-update.vue?vue&type=script&lang=js"
export * from "./add-or-update.vue?vue&type=script&lang=js"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=4dcfb7b8&prod&scoped=true&lang=css"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=4dcfb7b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfb7b8",
  null
  
)

export default component.exports